<script setup lang="ts">
	interface SocialItem {
		title: string,
		icon: string,
		url: string,
	}
	export type {
		SocialItem
	}

	const $props = defineProps<{
		items: Array<SocialItem>
	}>()
</script>

<template>
	<div v-if="$props.items?.length" class="flex flex-wrap gap-2.5 justify-start items-start w-full">
		<a v-for="social in $props.items" :href="social.url" :title="social.title" target="_blank" rel="nofollow" class="m-auto group">
			<GsIcon v-if="social.icon" :name="social.icon" class="flex-none text-black group-hover:text-accent transition duration-300 ease-in-out size-7" />
			<span class="sr-only" v-text="social.title"></span>
		</a>
	</div>
</template>
